import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RiSearchLine, RiEditLine, RiDeleteBin6Line, RiAddLine, RiStore3Line, RiMapPinLine, RiPhoneLine, RiFileList3Line, RiNumbersLine } from 'react-icons/ri';
import axios from 'axios';
import './MedicalStoreManagement.css';
import MedicalStoreModal from './MedicalStoreModal';

const MedicalStoreManagement = () => {
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStore, setSelectedStore] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        fetchStores();
    }, []);

    const fetchStores = async () => {
        try {
            const response = await axios.get('https://api.swasthmitra.com/api/stores/all');
            setStores(response.data.stores);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching stores:', error);
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this store?')) {
            try {
                await axios.delete(`https://api.swasthmitra.com/api/stores/${id}`);
                setMessage({ type: 'success', text: 'Store deleted successfully' });
                fetchStores();
            } catch (error) {
                console.error('Error deleting store:', error);
                setMessage({
                    type: 'error',
                    text: error.response?.data?.message || 'Error deleting store'
                });
            }
        }
    };

    const filteredStores = stores.filter(store =>
        store.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        store.address.toLowerCase().includes(searchTerm.toLowerCase()) ||
        store.mobile.includes(searchTerm) ||
        store.dlNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        store.gstNumber.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const MapDisplay = ({ store }) => {
        if (!store.mapIframe) {
            return <div className="store-map">No map available</div>;
        }

        return (
            <div className="store-map">
                <div dangerouslySetInnerHTML={{ __html: store.mapIframe }} />
            </div>
        );
    };

    return (
        <div className="store-management">
            <div className="header">
                <h2>Medical Store Management</h2>
                <div className="actions">
                    <div className="search-box">
                        <RiSearchLine />
                        <input
                            type="text"
                            placeholder="Search stores..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <button
                        className="add-btn"
                        onClick={() => {
                            setSelectedStore(null);
                            setIsEditing(false);
                            setShowModal(true);
                        }}
                    >
                        <RiAddLine /> Add Store
                    </button>
                </div>
            </div>

            {loading ? (
                <div className="loading">Loading stores...</div>
            ) : (
                <div className="stores-grid">
                    {filteredStores.map((store) => (
                        <motion.div
                            key={store._id}
                            className="store-card"
                            whileHover={{ scale: 1.02 }}
                        >
                            {store.storeImage && (
                                <div className="store-image">
                                    <img src={store.storeImage} alt={store.name} />
                                </div>
                            )}
                            <div className="store-info">
                                <h4><RiStore3Line /> {store.name}</h4>
                                <p className="dl-number">
                                    <RiFileList3Line /> DL: {store.dlNumber}
                                </p>
                                <p className="gst-number">
                                    <RiNumbersLine /> GST: {store.gstNumber}
                                </p>
                                <p className="address">
                                    <RiMapPinLine /> {store.address}
                                </p>
                                <p className="mobile">
                                    <RiPhoneLine /> {store.mobile}
                                </p>
                                <MapDisplay store={store} />
                            </div>
                            <div className="card-actions">
                                <button
                                    className="edit-btn"
                                    onClick={() => {
                                        setSelectedStore(store);
                                        setIsEditing(true);
                                        setShowModal(true);
                                    }}
                                >
                                    <RiEditLine /> Edit
                                </button>
                                <button
                                    className="delete-btn"
                                    onClick={() => handleDelete(store._id)}
                                >
                                    <RiDeleteBin6Line /> Delete
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </div>
            )}

            <AnimatePresence>
                {showModal && (
                    <MedicalStoreModal
                        store={selectedStore}
                        isEditing={isEditing}
                        onClose={() => {
                            setShowModal(false);
                            setSelectedStore(null);
                        }}
                        onSave={() => {
                            fetchStores();
                            setShowModal(false);
                        }}
                    />
                )}
            </AnimatePresence>
        </div>
    );
};

export default MedicalStoreManagement; 